import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect'

const NotTheApplicationUsers = () => {
    const [notTheApplicationUsers, setNotTheApplicationUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const reloadData = () => {
        setRefreshKey(prevKey => prevKey + 1);
    }; 

    useEffect(() => {
        const fetchNotTheApplicationUsers = async () => {
            setLoading(true);
            setError(null); // Сбрасываем ошибку перед новым запросом
            
            try {
                const response = await anotherInstance.get(`users/get`);
                // Проверяем наличие данных и тип
                if (response.data && Array.isArray(response.data.data)) {
                    // Обрабатываем данные, чтобы они соответствовали ожидаемой структуре

                    const processedData = response.data.data.map(user => ({
                        id: user.id,
                        User: {
                            userId: user.userId,
                            firstName: user.firstName,
                            username: user.username,
                            role: user.role,
                            userTimeStart: user.userTimeStart,
                            isBlocked: user.isBlock,
                            userTimeBlock: user.userTimeBlock,
                        },
                        Poll: {
                            // Извлекаем pollAnswer из массива Polls
                            pollAnswer: user.Polls.length > 0 ? user.Polls[0].pollAnswer : null,
                        },
                    }));
                    setNotTheApplicationUsers(processedData);
                } else {
                    setNotTheApplicationUsers([]); // Если пользователей нет или структура неправильная
                }
            } catch (error) {
                setError('Ошибка при получении пользователей!'); // Устанавливаем сообщение об ошибке
                setNotTheApplicationUsers([]); // Устанавливаем пустой массив при ошибке
            } finally {
                setLoading(false);
            }
        };

        fetchNotTheApplicationUsers();
    }, [refreshKey]);

    return { notTheApplicationUsers, loading, error, reloadData };
};

export default NotTheApplicationUsers;